import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

// Angular 10 has no addValidators/removeValidators. Share one composed validator
// across grid instances so destroying one section preserves the others and CAP's validators.
interface GridValidators {
  original: ValidatorFn;
  combined: ValidatorFn;
  rules: Map<object, ValidatorFn>;
}

const gridValidators = new WeakMap<FormGroup, GridValidators>();

export function registerRequiredAcsGridValidator(group: FormGroup, owner: object, rule: ValidatorFn): () => void {
  let state = gridValidators.get(group);
  if (!state) {
    state = { original: group.validator, combined: null, rules: new Map<object, ValidatorFn>() };
    const shared = state;
    shared.combined = control => {
      let errors: ValidationErrors = shared.original ? shared.original(control) || {} : {};
      shared.rules.forEach(validator => errors = { ...errors, ...(validator(control) || {}) });
      return Object.keys(errors).length ? errors : null;
    };
    gridValidators.set(group, shared);
    group.setValidators(shared.combined);
  }
  state.rules.set(owner, rule);
  group.updateValueAndValidity({ emitEvent: false });
  return () => {
    state.rules.delete(owner);
    if (!state.rules.size) {
      if (group.validator === state.combined) {
        group.setValidators(state.original);
      }
      gridValidators.delete(group);
    }
    group.updateValueAndValidity({ emitEvent: false });
  };
}
